import * as React from 'react';
import { Route } from 'react-router';

import NotFound from 'bundles/phoenix/components/NotFound';
import PremiumCertificateApp from 'bundles/premium-certificate/components/PremiumCertificateApp';
import MTDPPage from 'bundles/premium-certificate/components/mastertrack/MTDPPage';

export default (
  <Route path="/" component={PremiumCertificateApp}>
    <Route name="mtdp" component={MTDPPage} path="/mastertrack/:slug" />
    <Route name="ucertdp" component={MTDPPage} path="/certificates/:slug" />
    <Route name="mtdp-preview" component={MTDPPage} path="/mastertrack-preview/:slug" />
    <Route name="ucertdp-preview" component={MTDPPage} path="/certificate-preview/:slug" />
    {/* This catch-all *, status=404 route is important for SSR. */}
    <Route path="*" component={NotFound} />
  </Route>
);
